import * as A from '../types/actions';

export function openAlert(payload: A.OpenAlert['payload']): A.OpenAlert {
  return { type: 'ALERT_SERVICE:OPEN_ALERT', payload };
}

export function closeAlert(): A.CloseAlert {
  return { type: 'ALERT_SERVICE:CLOSE_ALERT' };
}
